import React, { createContext, useContext, useState, useEffect } from 'react';

import axios from 'axios';

import  {jwtDecode}  from "jwt-decode";



interface AuthContextType {

  isAuthenticated: boolean;

  isLoading: boolean;

  login: (token: string) => void;

  logout: () => void;

}



const AuthContext = createContext<AuthContextType | undefined>(undefined);



interface DecodedToken {

  id: number;

  iat: number;

  exp: number;

}



export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [isLoading, setIsLoading] = useState(true);



  useEffect(() => {

    const checkAuthStatus = async () => {

      const token = localStorage.getItem('token');

      if (token) {

        try {

          // Attempt to decode the token

          const decodedToken: DecodedToken = jwtDecode(token);

          const currentTime = Date.now() / 1000;

          

          // Check if token is expired

          if (decodedToken.exp < currentTime) {

            // Token is expired, log out

            await logout();

          } else {

            // Token is valid

            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            // Store user ID from token

            localStorage.setItem('userId', decodedToken.id.toString());

            setIsAuthenticated(true);

          }

        } catch (error) {

          // If token is invalid or can't be decoded, log out

          console.error('Invalid token:', error);

          await logout();

        }

      }

      setIsLoading(false);

    };



    checkAuthStatus();

  }, []);



  const login = (token: string) => {

    localStorage.setItem('token', token);

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // Decode token and store user ID

    const decodedToken: DecodedToken = jwtDecode(token);

    localStorage.setItem('userId', decodedToken.id.toString());

    setIsAuthenticated(true);

  };



  const logout = async () => {

    localStorage.removeItem('token');

    localStorage.removeItem('userId');

    delete axios.defaults.headers.common['Authorization'];

    setIsAuthenticated(false);

  };



  return (

    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>

      {children}

    </AuthContext.Provider>

  );

};



export const useAuth = () => {

  const context = useContext(AuthContext);

  if (context === undefined) {

    throw new Error('useAuth must be used within an AuthProvider');

  }

  return context;

};
